import React from "react";
import { Box, Typography } from "@mui/material";
import WarningAmberOutlinedIcon from "@mui/icons-material/WarningAmberOutlined";
import ModalShell from "./ModalShell";
import { CollectionVariant } from "../../../api/derin";
import { collectionColors, font, subtitleSx } from "./tokens";

interface RemoveVariantDialogProps {
  open: boolean;
  variant: CollectionVariant | null;
  onClose: () => void;
  onConfirm: () => void;
  isSubmitting?: boolean;
}

const RemoveVariantDialog: React.FC<RemoveVariantDialogProps> = ({
  open,
  variant,
  onClose,
  onConfirm,
  isSubmitting = false,
}) => {
  const hasResponses = (variant?.transcriptCount ?? 0) > 0;

  return (
    <ModalShell
      open={open}
      onClose={onClose}
      title="Remove variant"
      subtitle={
        variant
          ? `"${variant.label}" will be unlinked from this collection. The survey itself is not deleted — it stays available and can be linked again later.`
          : undefined
      }
      confirmLabel="Remove variant"
      onConfirm={onConfirm}
      isSubmitting={isSubmitting}
      danger
    >
      {hasResponses && variant && (
        <Box
          sx={{
            display: "flex",
            gap: "10px",
            padding: "12px",
            background: collectionColors.dangerSurface,
            borderRadius: "8px",
          }}
        >
          <WarningAmberOutlinedIcon sx={{ width: 18, height: 18, color: collectionColors.danger, flexShrink: 0 }} />
          <Box>
            <Typography
              sx={{
                fontFamily: font,
                fontWeight: 500,
                fontSize: "14px",
                lineHeight: "20px",
                color: collectionColors.danger,
              }}
            >
              {variant.transcriptCount} participant{variant.transcriptCount === 1 ? " has" : "s have"} already
              completed this variant
            </Typography>
            <Typography sx={{ ...subtitleSx, fontSize: "13px", lineHeight: "18px" }}>
              Those responses stop being analyzed as part of this collection.
            </Typography>
          </Box>
        </Box>
      )}
      {variant && <Typography sx={subtitleSx}>Variant ID: {variant.surveyOriginalId}</Typography>}
    </ModalShell>
  );
};

export default RemoveVariantDialog;
